<template>
  <div>
    <div class="top-page-content">
      <rego-search></rego-search>
      <car-info></car-info>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
import RegoSearch from "@/components/top-page/RegoSearch";
import CarInfo from "@/components/top-page/Info";
import FooterView from "@/components/layout/Footer";

export default {
  name: "Index",
  components: {
    RegoSearch,
    CarInfo,
    FooterView,
  },
  mounted() {
    this.$store.dispatch('getSystemConfigurations');
  }
};
</script>

<style lang="scss">
.top-page-content {
  color: #404040;
  text-align: center;
  background-color: #efefef;
}
</style>
